import { render, staticRenderFns } from "./SideDrawer.vue?vue&type=template&id=bfd366ea&scoped=true"
import script from "./SideDrawer.vue?vue&type=script&lang=js"
export * from "./SideDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfd366ea",
  null
  
)

export default component.exports